import { render } from "./TodayAppointments.vue?vue&type=template&id=37f628dc&scoped=true"
import script from "./TodayAppointments.vue?vue&type=script&lang=js"
export * from "./TodayAppointments.vue?vue&type=script&lang=js"

import "./TodayAppointments.vue?vue&type=style&index=0&id=37f628dc&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f628dc"]])

export default __exports__